import api from '../service/apiService'
import { apiUrl } from '../constants/apiUrl'
import { errorAction } from './error';
import { getCartHeader, getCartData, getCartProducts,getCartDataDefault,getUnsupportedProducts } from './../util/cartUtility';
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../service/logService';
import { InHomeUtils } from '../util/inhomeUtils';
import { redirectTo } from './redirection';
import { Pages, CheckOut, PAGEACTIVITY ,BannerTypes, Service } from './../constants/actionType';
import * as checkoutAction from './checkout';
import * as buildProductAction from './buildProduct';
import * as lqAction from './loopQual';
import { tempSCData } from '../service/dtmTag';

export const getSuppOrStack = (dispatch, visitID, vCustID, vActID, state, mon, flowType,orderEncryted,buildProductState, lqState) => {
    let url = apiUrl().vzOrderInfo;
    let agencyID = new URLSearchParams(window.location?.search)?.get('agency');
    if(agencyID !== null && agencyID !== undefined){
      window.sessionStorage.setItem('agencyID', agencyID);
    }
    if(window.location.search?.includes('MN=Y') || window.sessionStorage.getItem('isMidnight') === 'true') {
        url = url +'?isMnFlow=Y'
    }
    if(window.location.search?.includes('agency=CETCORDER2')) {
        window.sessionStorage.setItem('isWIFI7', true);
    }
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" } });
    api(url, 'POST', getVZInfoRequest(vCustID, vActID, state,orderEncryted)).then(response => {
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
            if (InHomeUtils.isNotNull(response.data)) {
                dispatch({ type: 'UPDATE_BASEORDERINFO', value: response.data });
                    if (InHomeUtils.isNotEmpty(response.data.isFVWinbackOrder) && response.data.isFVWinbackOrder === "Y") {
                        errorAction("LBO", "SUPP", "", "applogs", visitID, dispatch, true, "WinbackSuppOrder");
                    }
                    else if (InHomeUtils.isNotEmpty(response.data.vzDisqualifier) && (response.data.vzDisqualifier === "Multiline" || response.data.vzDisqualifier === "IsVirtualLine" || response.data.vzDisqualifier === "hasMOBILITYProduct")) {
                        errorAction("LBO", "SUPP", "", "applogs", visitID, dispatch, true, "BTNNotQualify-SUPP");
                    }
                    else if ((InHomeUtils.isNotEmpty(response.data.isSupp) && response.data.isSupp === "Y") || mon=="NJ40004743720") {
                        let vzorderres = response.data;
                        //fetch all banners and store
                        lqAction.fetchBanners(dispatch, visitID);
                        lqAction.updateBannerType(BannerTypes.Supp, dispatch);    
                        let lqResponseSupp = updateLqResponseSupp(dispatch, response.data);
                        Promise.all([lqResponseSupp]).then(response => {
                            getVZOrderDetails(dispatch, visitID, state, mon,flowType,orderEncryted,buildProductState, lqState,false,vzorderres);
                        });
                    }
                    else {
                        errorAction("LBO", "SUPP", "", "applogs", visitID, dispatch, true, "StackOrder");
                    }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        }
        else {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            errorAction("LBO", "SUPP", "", "applogs", visitID, dispatch, true, "BASEORDERFAIL-NCOG-ERR");
        }
    })
        .catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            errorAction("ERROR", "getVZOrderInfo", error.message, "applogs", visitID, dispatch, false, "");
        });
}


export const getVZOrderDetails = (dispatch, visitID, state, mon,flowType,orderEncryted,buildProductState, lqState,Retry=false,vzorderresponse, reAttemptCount = 0) => {
    let url = apiUrl().vzOrderDetail;
    if(window.location.search?.includes('MN=Y') || window.sessionStorage.getItem('isMidnight') === 'true') {
        url = url + '?isMnFlow=Y'
    }
    var host = window.location.host;
    var isProd = false;
    if(host === ATOM_CONST.PROD){
        isProd = true;
    }
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Please wait ... retrieving services available at your location.", isLoaderImg: "loader" } });
    api(url, 'POST', getVZDetailRequest(state, mon,orderEncryted)).then(response => {
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
            dispatch({ type: 'UPDATE_BASEORDERDETAIL', value: response.data });
            creditCheckSupp(visitID,dispatch);
            if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.commondetails) && InHomeUtils.isNotEmpty(response.data.commondetails.errorMsg)) {
                logKafka("ERROR", "BASEORDERFAIL", response.data.commondetails.errorMsg, apiUrl().kafkaErrorAppLogs, "applogs", visitID);
                errorAction("LBO", "SUPP", "", "applogs", visitID, dispatch, true, "BASEORDERFAIL");
             }
            else if (flowType === 'postpaidsupp' && InHomeUtils.isNotNull(response?.data) && InHomeUtils.isNotNull(response?.data?.vzOrder?.holdForSublocationCreation) && response?.data?.vzOrder?.holdForSublocationCreation === "Y") {
                logKafka("ERROR", "SUPP", "holdForSubloc", apiUrl().kafkaErrorAppLogs, "applogs", visitID);
                errorAction("LBO", "SUPP", "", "applogs", visitID, dispatch, true, "holdForSubloc");
            }
              else {
                if (InHomeUtils.isNotEmpty(response) && InHomeUtils.isNotEmpty(response.data)&&InHomeUtils.isNotEmpty(response.data.vzOrder) &&InHomeUtils.isNotEmpty(response.data.vzOrder.isHOAFlow) && response.data.vzOrder.isHOAFlow === "Y") {
                    errorAction("LBO", "SUPP", "HOA", "", visitID, dispatch, true, "hoa");
                } else {
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.vzDirectoryInfo) && InHomeUtils.isNotEmpty(response.data.vzDirectoryInfo.btn)) {
                    dispatch({ type: 'SUPP_LOADTN', value: response.data.vzDirectoryInfo.btn });
                }
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.vzOrder) && InHomeUtils.isNotNull(response.data.vzOrder.profileFFCouponInfo) && InHomeUtils.isNotNull(response.data.vzOrder.profileFFCouponInfo.ffCouponCode) && InHomeUtils.isNotNull(response.data.vzOrder.profileFFCouponInfo.ffLeadListId) && InHomeUtils.isNotEmpty(response.data.vzOrder.profileFFCouponInfo.ffCouponCode) && InHomeUtils.isNotEmpty(response.data.vzOrder.profileFFCouponInfo.ffLeadListId)) {
                    let ffValidationInfo = {
                        ffCoupon: response.data.vzOrder.profileFFCouponInfo.ffCouponCode,
                        leadListID: response.data.vzOrder.profileFFCouponInfo.ffLeadListId,
                        ffCouponError: false,
                        ffValidationSucess: true,
                        ffValidationFailure: false,
                        ffValidationErrorType:  '', 
                        isFFCheckoutValidation: false,
                        profileDataSpeed: (InHomeUtils.isNotNull(response.data.vzOrder.profileFFCouponInfo.profileDataSpeed) && InHomeUtils.isNotEmpty(response.data.vzOrder.profileFFCouponInfo.profileDataSpeed)) ? response.data.vzOrder.profileFFCouponInfo.profileDataSpeed : '',
                        profileFFDiscount: true
                    }
                    dispatch({ type: 'FFCOUPONVALIDATIONSUCCESS', value: ffValidationInfo });
                }
                
                //Visible & prePaid change
                if (InHomeUtils.isNotNull(response.data) && response.data.vzOrder && InHomeUtils.isNotNull(response.data.vzOrder.vzwCouponCode) && response.data.vzOrder.vzwCouponCode) {
                    let visPreCouponInfo = {
                     visPreCoupon:  response.data.vzOrder.vzwCouponCode,
                     leadListID: null,
                     visPreCouponError: false,
                     visPreValidationSucess: true,
                     visPreValidationFailure: false,
                     visPreValidationErrorType: '',
                     isVisPreCheckoutValidation: false,
                     isDiscountEligible: true,
                     isDiscountApplied: true
                   }
                   dispatch({ type: 'VISPRECOUPONVALIDATIONSTATUS', value: visPreCouponInfo });
                 }
                //VZ Connections change for getting token info 
                if(InHomeUtils.isNotNull(response.data.vzOrder) && InHomeUtils.isNotNull(response.data.vzOrder.tokenInfo) && InHomeUtils.isNotNull(response.data.vzOrder.tokenInfo.companyToken) && InHomeUtils.isNotEmpty(response.data.vzOrder.tokenInfo.companyToken) && InHomeUtils.isNotNull(response.data.vzOrder.tokenInfo.customerToken) && InHomeUtils.isNotEmpty(response.data.vzOrder.tokenInfo.customerToken) && InHomeUtils.isNotNull(response.data.vzOrder.tokenInfo.tokenType) && InHomeUtils.isNotEmpty(response.data.vzOrder.tokenInfo.tokenType) && response.data.vzOrder.tokenInfo.tokenType === "VzConnection"){
                    let vzcCouponInfo = {
                        vzcCoupon: response.data.vzOrder.tokenInfo.customerToken,
                        vzcValidationSuccess: true,
                        isDiscountEligible: true
                    }
                    dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo }); 
                }
                if(response.data.vzOrder.hasSlingTv === "Y"){
                    updateLqResponseSupp(dispatch,vzorderresponse,true);
                }
                lqAction.isFCPflow(response.data.vzOrder.isFCP, dispatch)
                let lqDetailSupp = updateLqDetailSupp(dispatch, response.data);
                Promise.all([lqDetailSupp]).then(response => {
                    loadCartForSupp(dispatch, visitID, buildProductState, flowType, response, lqState);
                });
            }
            }
        }
        else if(reAttemptCount<3){
            getVZOrderDetails(dispatch, visitID, state, mon,flowType,orderEncryted,buildProductState, lqState,Retry,vzorderresponse, reAttemptCount+1);
        }
        else {
            // if(!Retry && !isProd){ 
            //     logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.SD, visitID, 'getVZOrderDetails', "getVZOrderDetails-ReAttempt", PAGEACTIVITY.UA));
            //     getVZOrderDetails(dispatch, visitID, state, mon,flowType,orderEncryted,buildProductState,lqState,true,vzorderresponse);
            // } else {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            errorAction("LBO", "SUPP", "", "BASEORDERFAIL", visitID, dispatch, true, "BASEORDERFAIL");
           //}
        }
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    })
        .catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            errorAction("ERROR", "getVZOrderDetails", error.message, "applogs", visitID, dispatch, false, "");
        });
}

const getVZInfoRequest = (vCustID, vActID, state,orderEncryted) => {
    let request = {
        VisionCustomerId: InHomeUtils.isNotNull(vCustID)?vCustID:"",
        VisionAccountId: InHomeUtils.isNotNull(vActID)?vActID:"",
        serviceState: InHomeUtils.isNotNull(state)?state:"",
        order:encodeURIComponent(orderEncryted)
    }
    return JSON.stringify(request)
}

const getVZDetailRequest = (state, mon,orderEncryted) => {
    let request = {
        mon: InHomeUtils.isNotNull(mon)?mon:"",
        serviceState: InHomeUtils.isNotNull(state)?state:"",
        order:encodeURIComponent(orderEncryted)
    }
    return JSON.stringify(request)
}

const updateLqResponseSupp = (dispatch, response,slinginProfile=false) => {
    let qualifedServices = {
        qualified: 'Y', fiosReady: 'N', quantumEligible: 'N', fiosSelfInstall: 'N',
        services: [{ servicename: 'FiOSData', qualified: 'N' }, { servicename: 'Video', qualified: 'N' },
        { servicename: 'Voice', qualified: 'N' }]
    };
    let servicesQualified = {
        isDataQualified: true,
        isHsiQualified: false,
        isVideoQualified: true,
        isVoiceQualified: true
    };
    if (response.fibreisChangable === 'Y') {
        qualifedServices.services[0].qualified = 'Y';
        servicesQualified.isDataQualified = true;
    } else {
        qualifedServices.services[0].qualified = 'N';
        servicesQualified.isDataQualified = false;
    }
    if (response.videoisChangable === 'Y' || slinginProfile) {
        qualifedServices.services[1].qualified = 'Y';
        servicesQualified.isVideoQualified = true;
    } else {
        qualifedServices.services[1].qualified = 'N';
        servicesQualified.isVideoQualified = false;
    }
    if (response.fiosVoiceisChangable === 'Y') {
        qualifedServices.services[2].qualified = 'Y';
        servicesQualified.isVoiceQualified = true;
    } else {
        qualifedServices.services[2].qualified = 'N';
        servicesQualified.isVoiceQualified = false;
    }
    dispatch({ type: "LQ_ON_CHECK_AVAILABILITY_CLICK", value: qualifedServices });
    dispatch({ type: 'LQ_SET_QUALIFIED_SERVICES', value: servicesQualified });
}

const updateLqDetailSupp = (dispatch, response) => {
    if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.commondetails) && InHomeUtils.isNotEmpty(response.commondetails.addressID)) {
        let addressRequest = {
            addressID: response.commondetails.addressID,
            baseAddID: response.commondetails.addressID,
            street: response.commondetails.addressLine1,
            unit: response.commondetails.addressLine2,
            city: response.commondetails.city,
            state: response.commondetails.state,
            zip: response.commondetails.zip,
            tarCode:response.commondetails.tar
        }
        dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDSTATE', value: addressRequest });
        dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDADDRESS', value: addressRequest });
        if (response.commondetails.addressLine2 !== "") {
            dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDUNIT', value: addressRequest });
        }
    }
}

const loadCartForSupp = (dispatch, visitId, buildProductState,flowType,vzOrderResponse, lqState, isLoadCartFailed = false) => {
    try {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.SD, visitId, 'loadCartForSupp', "Inside loadCartForSupp", PAGEACTIVITY.UA));
        let getCart = apiUrl().getCartAcc + '/' + visitId;
        var host = window.location.host;
        var isProd = false;
        if(host === ATOM_CONST.PROD){
            isProd = true;
        }
        api(getCart, 'GET', '').then(response => {
            if (InHomeUtils.isNull(response)) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.SD, visitId, 'loadCartForSupp', 'RETRIEVECART-RESPONSEEMPTYORNULL', PAGEACTIVITY.UA));
            } else {
                if (InHomeUtils.isNull(response.data)) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.SD, visitId, 'loadCartForSupp', 'RETREIVECART-DATANULL', PAGEACTIVITY.UA));
                }

                if (InHomeUtils.isNotNull(response.meta)) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.SD, visitId, 'loadCartForSupp', "META VALUE:" + response.meta.code, PAGEACTIVITY.UA));
                }
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.data)) {
                if (InHomeUtils.isNotNull(response.data.cartTierPricing)){
                    let cartDataOnResume = getCartDataDefault();
                    cartDataOnResume = getCartData(response.data.cartTierPricing.tierContent, visitId);
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: cartDataOnResume,
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                });

                dispatch({
                    type: "PROFILE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: cartDataOnResume,
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                })

                //Load Profile required object - Used for DTm Tagging at later stages
                getUnsupportedProducts(response.data, dispatch, visitId,true);
                loadDTMProfileObject(cartDataOnResume,dispatch,visitId);
                let hasDVR = (vzOrderResponse && vzOrderResponse.data && vzOrderResponse.data.hasDVR && vzOrderResponse.data.hasDVR === "Y");
                if(!hasDVR){
                    let product = [{ id: 'NORECORD', prodType: 'VFEATURE', name: "I don't want to record on any TV's" }];
                    dispatch({type:'RECORDING_SELECTEDPROD',  value:product[0]})
                }

                if (InHomeUtils.isNotNull(cartDataOnResume) && InHomeUtils.isNotNull(cartDataOnResume[0]) 
                            && InHomeUtils.isNotNull(cartDataOnResume[0].fiosFiveSelectedChannels) && cartDataOnResume[0].fiosFiveSelectedChannels.length > 0) {
                                let cartDataChannels = [];
                                if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.fiosFiveBasicChannels) && buildProductState.tv.fiosFiveBasicChannels.length > 0) {
                                    cartDataOnResume[0].fiosFiveSelectedChannels.forEach((item) => {
                                        let matchesFound = filterFiosFiveBasicChannels(buildProductState.tv.fiosFiveBasicChannels, item);
                                        if (matchesFound && matchesFound.length) {
                                            cartDataChannels.push(matchesFound[0]);
                                        }
                                    })

                                    if(cartDataChannels.length >0){
                                        cartDataChannels = formatSelectedFiosFiveChannels(cartDataChannels);
                                        dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS_PROFILE', value: cartDataChannels });
                                        dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                                    }else{
                                        cartDataChannels = formatSelectedFiosFiveChannels(cartDataOnResume[0].fiosFiveSelectedChannels);
                                        dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS_PROFILE', value: cartDataChannels });
                                        dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                                    }
                                }else{
                                    cartDataChannels = formatSelectedFiosFiveChannels(cartDataOnResume[0].fiosFiveSelectedChannels);
                                    dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS_PROFILE', value: cartDataChannels });
                                    dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                                }
                                if(InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.vzDirectoryInfo) && InHomeUtils.isNotEmpty(response.data.vzDirectoryInfo.btn)){
                                    let tn = response.data.vzDirectoryInfo.btn
                                    if (tn !== "" && tn !== "1000000001" && tn !== "9999999999") {
                                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'updateRequestTNForFDV', "Triggering updateRequestTNForFDV", PAGEACTIVITY.UA));                                    
                                        buildProductAction.updateRequestTNForFDV(visitId, tn, dispatch);
                                    }
                                }
                            }
            }
            if (flowType === "CDD") {
                if (InHomeUtils.isNotEmpty(vzOrderResponse.data.isHoldOrder) && vzOrderResponse.data.isHoldOrder === "Y" && InHomeUtils.isNotEmpty(vzOrderResponse.data.holdReason) && vzOrderResponse.data.holdReason === "CADDR") {
                    //call VO if success - redirect to checkout and failed --redirect to lbo with VOFailed.  
                    checkoutAction.doValidateCart(visitId, dispatch, 'SUPP-LANDING',"","",buildProductState)          
                }
                else {
                    errorAction("LBO", "SUPP", "", "applogs", visitId, dispatch, true, "CreditHoldClearSubmitted");
                }
            }
            else {
                redirectTo(Pages.BuildProduct, dispatch);
                dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })
                checkoutAction.updatePersonalInfoAccordion('completed', dispatch);
                checkoutAction.updateCreditCheckAccordion('completed', dispatch);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });                    
            }
            }
            // else if (!isLoadCartFailed && !isProd) {
            //     logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.SD, visitId, 'loadCartForSupp', "loadCartForSupp-ReAttempt", PAGEACTIVITY.UA));
            //     loadCartForSupp(dispatch, visitId,flowType, vzOrderResponse, lqState, true);
            // }
            else{
                errorAction("LBO", "GetOrderDetail", "LoadGetCart-PostProfile", "SuppCartFail", visitId, dispatch, true, "SuppCartFail");
            }
        })
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.SD, visitId, 'action-loadCartForSupp', ex);
        errorAction("LBO", "GetOrderDetail", "LoadGetCartException", "SuppCartFail", visitId, dispatch, true, "SuppCartFail");
    }
}

const loadDTMProfileObject = (cartData,dispatch,visitId)=>{
    try{
        console.log("Inside loadDTMProfileObject");
        //console.log(cartData);
        let lstProfileObjects =[];
    
        if(InHomeUtils.isNotNull(cartData) && InHomeUtils.isNotNull(cartData[0].serviceHeaders) && InHomeUtils.isNotNull(cartData[0].serviceHeaders.servicehead)){
            cartData[0].serviceHeaders.servicehead.map((srvcObj) =>{
                return (
                    lstProfileObjects.push({ prodId: srvcObj.prodId, prodName: srvcObj.prodName, prodType: srvcObj.prodType, prodTypeVal: srvcObj.prodTypeVal, speedCode: srvcObj.speedCode }))
            
            });
        }  

        if(InHomeUtils.isNotNull(cartData) && InHomeUtils.isNotNull(cartData[0].internet) && InHomeUtils.isNotNull(cartData[0].internet.internetProds)){
            cartData[0].internet.internetProds.map((srvcObj) =>{
                return (
                    lstProfileObjects.push({ prodId: srvcObj.prodId, prodName: srvcObj.prodName, prodType: srvcObj.prodType, prodTypeVal: srvcObj.prodTypeVal }))
            
            });
        }  

        if(InHomeUtils.isNotNull(cartData) && InHomeUtils.isNotNull(cartData[0].channel) && InHomeUtils.isNotNull(cartData[0].channel.channelsProds)){
            cartData[0].channel.channelsProds.map((srvcObj) =>{
                return (
                    lstProfileObjects.push({ prodId: srvcObj.prodId, prodName: srvcObj.prodName, prodType: srvcObj.prodType, prodTypeVal: srvcObj.prodTypeVal }))
            
            });
        } 

        if(InHomeUtils.isNotNull(cartData) && InHomeUtils.isNotNull(cartData[0].equipments) && InHomeUtils.isNotNull(cartData[0].equipments.equipment)){
            cartData[0].equipments.equipment.map((srvcObj) =>{
                return (
                    lstProfileObjects.push({ prodId: srvcObj.prodId, prodName: srvcObj.prodName, prodType: srvcObj.prodType, prodTypeVal: srvcObj.prodTypeVal }))
            
            });
        } 

        if(InHomeUtils.isNotNull(cartData) && InHomeUtils.isNotNull(cartData[0].oneTimeCharge) && InHomeUtils.isNotNull(cartData[0].oneTimeCharge.onetimecharge)){
            cartData[0].oneTimeCharge.onetimecharge.map((srvcObj) =>{
                return (
                    lstProfileObjects.push({ prodId: srvcObj.prodId, prodName: srvcObj.prodName, prodType: srvcObj.prodType, prodTypeVal: srvcObj.prodTypeVal }))
            
            });
        }


        
        dispatch({
            type: "UPDATE_PROFILE_DTM_PRODUCTS",
            value: lstProfileObjects        
        })
    
        tempSCData.profileProduct=lstProfileObjects;
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.SD, visitId, 'action-loadDTMProfileObject', ex);       
    }
    
}

const filterFiosFiveBasicChannels = (lstChannels, prodId) => {
    let lstMatchedChannel = [];

    if (prodId) {
       // prodId = prodId.toUpperCase();
        lstMatchedChannel = lstChannels.filter((el) => {
            return (el.id.toUpperCase().indexOf(prodId) !== -1)
        });
    }
    return lstMatchedChannel;
}

const formatSelectedFiosFiveChannels = (cartDataChannels) => {
    cartDataChannels = cartDataChannels.map(val =>{
        val.id = val.id || val.prodId;
        val.name = val.name || val.prodName;
        val.logo = val.logo || val.id+'.png';
        return val;
        }).filter(item => {
           // prodType: 'BASIC_FF', //Todo
           let prodTypeVal = item.prodTypeVal ? item.prodTypeVal.trim(): ''
            return prodTypeVal.toLowerCase() !== "musthavea" && prodTypeVal.toLowerCase() !== "musthaveb";
        });
        return cartDataChannels;
}

export const getHTMLContent = (dispatch) => {
    const url = "https://www98.verizon.com/includes/commongh/";
    api(url, 'GET', '', 'html').then(response => {
        const content = {
            type: 'SUPP_HEADER',
            value: response
        }
        dispatch(content);
    }).catch(error => {
        console.log('html error', error);
    });
}

export const suppDueDateInvoked = (status, dispatch) => {
    dispatch({ type: 'SUPP_DUEDATEINVOKED', value: status })
};

export const suppDueDateAvailable = (dueDateAvailable, dispatch) => {
    dispatch({ type: 'SUPP_DUEDATEAVAILABLE', value: dueDateAvailable })
};

export const updateProfiletoNewCart = (visitId, dispatch, buildProductState, lqState, cartState,supphasDVR) => {
    try {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
        let jsonstr = JSON.stringify({ 'flowType':'SUPP' });
        let suppCancelCart = apiUrl().suppCancelCart + visitId;
        api(suppCancelCart, 'POST', jsonstr).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.data)) {
                let getCart = apiUrl().getCartAcc + '/' + visitId;
                api(getCart, 'GET', '').then(response => {
                    if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.data)) {
                        if (InHomeUtils.isNotNull(response.data.cartTierPricing)){
                        let cartDataOnResume = getCartDataDefault();
                        cartDataOnResume = getCartData(response.data.cartTierPricing.tierContent, visitId);
                        dispatch({
                            type: "UPDATE_CART",
                            value: {
                                cartResponse: response.data.cartTierPricing,
                                cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                                cartData: cartDataOnResume,
                                cartOrderDetail: response.data.orderDetail,
                                cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                            }
                        });
                        // Clear special offer selected product if not in cart response
                        const cartSplOffers = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(s => s?.sectionName === "Promotions")?.subSections?.subSection?.find(s => s?.sectionType === "SpecialOffers")?.promos
                            || response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(s => s?.sectionName === "Promotions")?.subSections?.subSection?.find(s => s?.sectionType === "SpecialOffers")?.promotions
                            || response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(s => s?.sectionName === "Promotions")?.subSections?.subSection?.find(s => s?.sectionType === "SpecialOffers")?.products;
                        if (!Array.isArray(cartSplOffers) || cartSplOffers?.length === 0) {
                            dispatch({ type: "SPLOFFER_SELECTEDPRODID", value: null });
                            dispatch({ type: "SPLOFFER_SELECTEDPRODID_DATA", value: null });
                            dispatch({ type: "SPLOFFER_SELECTEDPRODID_TV", value: null });
                        } else {
                            const splOfferProductList = buildProductState?.contract?.contractType === 'MTM' ? buildProductState?.sploffer?.offerplansMTM?.filter(offer => offer?.id != "R4139") : buildProductState?.sploffer?.offerplans2YR?.filter(offer => offer?.id != "R4139");
                            const splOfferData = splOfferProductList?.find(p => cartSplOffers?.filter(s => s?.offerFor?.toUpperCase() === Service.data)?.findIndex(x => x?.id === p?.id) > -1);
                            if (!splOfferData) {
                                dispatch({ type: "SPLOFFER_SELECTEDPRODID_DATA", value: null });
                            } else {
                                dispatch({ type: "SPLOFFER_SELECTEDPRODID_DATA", value: splOfferData });
                            }
                            const splOfferTv = splOfferProductList?.find(p => cartSplOffers?.filter(s => s?.offerFor?.toUpperCase() === Service.tv)?.findIndex(x => x?.id === p?.id) > -1);
                            if (!splOfferTv) {
                                dispatch({ type: "SPLOFFER_SELECTEDPRODID_TV", value: null });
                            } else {
                                dispatch({ type: "SPLOFFER_SELECTEDPRODID_TV", value: splOfferTv });
                            }
                        }
                        if (InHomeUtils.isNotNull(cartDataOnResume) && InHomeUtils.isNotNull(cartDataOnResume[0]) 
                        && InHomeUtils.isNotNull(cartDataOnResume[0].fiosFiveSelectedChannels) && cartDataOnResume[0].fiosFiveSelectedChannels.length > 0) {
                            let cartDataChannels = [];
                            if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.fiosFiveBasicChannels) && buildProductState.tv.fiosFiveBasicChannels.length > 0) {
                                cartDataOnResume[0].fiosFiveSelectedChannels.forEach((item) => {
                                    let matchesFound = filterFiosFiveBasicChannels(buildProductState.tv.fiosFiveBasicChannels, item);
                                    if (matchesFound && matchesFound.length) {
                                        cartDataChannels.push(matchesFound[0]);
                                    }
                                })

                                if(cartDataChannels.length >0){
                                    cartDataChannels = formatSelectedFiosFiveChannels(cartDataChannels);
                                    dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                                }else{
                                    cartDataChannels = formatSelectedFiosFiveChannels(cartDataOnResume[0].fiosFiveSelectedChannels);
                                    dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                                }
                            }else{
                                cartDataChannels = formatSelectedFiosFiveChannels(cartDataOnResume[0].fiosFiveSelectedChannels);
                                dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: cartDataChannels });
                            }
                        }
                        let cartProducts = "";
                        buildProductAction.clearPreviousSelection(dispatch);
                        dispatch({ type: 'SUPP_PROFILEBACKTOCART', value: true })
                        let addlInfo = {
                            zip: lqState.selectedState.zip,
                            state: lqState.selectedState.state,
                            tarCode: lqState.selectedState.tarCode,
                            masterpackageview: buildProductState.masterpackageview,
                            selectedProductId: "",
                            couponFlowType: lqState.couponFlowType,
                            EquipmentState: buildProductState.loadedEquipments,
                            isFCPflow: lqState.isFCPFlow,
                            isAlaCarte: false,
                            flowType: "SUPP",
                            servicesQualified: lqState.servicesQualified,
                            regionId: buildProductState.tv.fiosFiveSearchVhoParams.regionId,
                        };
                        let additionalInfo = { flowType: "SUPP", isUpsell: false, couponFlowType: lqState.couponFlowType, orderType: "SUPP", vcpestbQty: '' };
                        cartProducts = getCartProducts(response.data.cartTierPricing, visitId);
                        let contract = '';
                        if (InHomeUtils.isNotNull(response.data.orderDetail) && InHomeUtils.isNotNull(response.data.orderDetail.contract)) {
                            contract = response.data.orderDetail.contract;
                        }
                        buildProductAction.PreselectCartProducts(cartProducts, dispatch, visitId, additionalInfo, null, buildProductState, lqState, cartState, addlInfo.servicesQualified,false,supphasDVR)
                        buildProductAction.fetchOfferInCart(visitId, cartProducts,dispatch, contract,null,null,null,false,lqState);
                        buildProductAction.getSpecialOffers(visitId, contract, dispatch);
                        //Load Profile required object - Used for DTm Tagging at later stages
                        getUnsupportedProducts(response.data, dispatch, visitId,true);
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }
                    else {
                        errorAction("ERROR", "BuildProduct", "LoadProfileCartTierError", "LoadProfileBack", visitId, dispatch, false, "LoadProfileBack");
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }
                }
                    else {
                        errorAction("ERROR", "BuildProduct", "LoadProfileCartResponseError", "LoadProfileBack", visitId, dispatch, false, "LoadProfileBack");
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }
                })
            }
            else {
                errorAction("ERROR", "BuildProduct", "LoadProfileCartResponseError", "LoadProfileBack", visitId, dispatch, false, "LoadProfileBack");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.SD, visitId, 'action-LoadProfileCart', ex);
        errorAction("ERROR", "BuildProduct", "LoadProfileCartException", "LoadProfileBack", visitId, dispatch, false, "LoadProfileBack");
    }

}

export const validateCartSupp = (visitId, dispatch, flowType, vzOrder, isvalidated,fiab,buildProductState ) => {
    dispatch({ type: 'SUPP_DUEDATEINVOKED', value: isvalidated })
    checkoutAction.doValidateCart(visitId, dispatch, "BuildProduct", flowType,"",buildProductState);
    checkoutAction.getDueDates(dispatch, visitId, "",flowType, vzOrder,fiab);
    buildProductAction.fetchPostSoc(dispatch,visitId,"",true);
    dispatch({ type: 'SUPP_CART_VALIDATED', value: isvalidated })
};

const creditCheckSupp = (visitId, dispatch) => {
    try {        
        let url = apiUrl().creditRefreshSupp;
        api(url, 'GET', ).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200")) {
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.icredit) && InHomeUtils.isNotNull(response.data.icredit.wirelessInfo)){
                    dispatch({ type: 'SUPP_VISIONDETAILS', value: response.data.icredit.wirelessInfo });
                }
            }
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            logOtherInfo(detailsInfo('GETORDERDETAIL', visitId, 'creditCheckSupp', "creditCheckSupp - exception"));
            let errorMsg = `MethodName:creditCheckSupp,errorMessage:${error.message}`;
            logKafka("ERROR", "creditCheckSupp", errorMsg, getErrorLogUrl, "applogs", visitId);
        });
    }
    catch (ex) {
        catchJSException('GETORDERDETAIL', visitId, 'creditCheckSupp', ex);
    }
}

const ATOM_CONST = {
    PRODURL: "www.verizon.com",
    PRODEASTURL: "wwwordering-prod-east-yz.vpc.verizon.com",
    STAGEURL: "www98.verizon.com",
    PILOTURL: "orderinglite.verizon.com",
    PREPROD: "preprod-east-gz.vpc.verizon.com",
    SITURL: "wwwawssit.ebiz.verizon.com",
    UATURL: "wwwawsuat.ebiz.verizon.com",
    NTE1URL: "wwwnte1aws.ebiz.verizon.com",
    NTE3URL: "wwwnte3aws.ebiz.verizon.com",
    NTE4URL: "wwwnte4aws.ebiz.verizon.com",
    NTE5URL: "wwwnte5aws.ebiz.verizon.com",
    ESPANOL: "espanol.verizon.com",
    LOCALURL: "localhost:3000"
};